import {
  DomesticOrderListSortField,
  ExporOrderListUrlQueryParams
} from "@saleor/changeOrderDomestic/urls";
import {
  DomesticOrderQueryParams,
  DomesticOrderSortField
} from "@saleor/createOrderDomestic/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { RouteComponentProps } from "react-router";

import Orders from "./views/Orders";
import ViewEditOrder from "./views/ViewEditOrder";

export const ChangeOrderViewDomestic: React.FC<RouteComponentProps<any>> = ({
  match
}) => {
  const qs = parseQs(location.search.substr(1));
  const params: DomesticOrderQueryParams = asSortParams(
    qs,
    DomesticOrderSortField,
    DomesticOrderSortField.item_no
  );
  return (
    <ViewEditOrder id={decodeURIComponent(match.params.id)} params={params} />
  );
};

export const OrderListView: React.FC<RouteComponentProps<any>> = () => {
  const qs = parseQs(location.search.substr(1));
  const params: ExporOrderListUrlQueryParams = asSortParams(
    qs,
    DomesticOrderListSortField,
    DomesticOrderListSortField.piNo
  );
  return <Orders params={params} />;
};
